import { render, staticRenderFns } from "./ChecklistBeforeGame.vue?vue&type=template&id=0b4f0383&scoped=true"
import script from "./ChecklistBeforeGame.vue?vue&type=script&lang=js"
export * from "./ChecklistBeforeGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f0383",
  null
  
)

export default component.exports